import { IOption } from 'utils/types';
import { L1Suffix, L2Suffix } from 'utils/constants';

export const MAX_FILTERS_LENGTH = 1000;

export interface IFilterProp {
  l1Code: string;
  l2Code?: string | null;
}

export const getUpdatedFilterOptions = (
  selectedFilter: IFilterProp,
  options: IOption[],
  selected?: boolean
) => {
  const { l1Code, l2Code } = selectedFilter;
  const newOptions = [...options];
  const filterOptionIndex = options.findIndex((item) => item.id === l1Code);
  const filterOption = options[filterOptionIndex];

  if (!filterOption) {
    return options;
  }

  if (!l2Code) {
    const newIsSelectedState =
      selected !== undefined ? selected : !filterOption.isSelected;
    const newFilterOption = {
      ...filterOption,
      isSelected: newIsSelectedState,
      options: filterOption.options?.map((item) => ({
        ...item,
        isSelected: newIsSelectedState,
      })),
    };

    newOptions[filterOptionIndex] = newFilterOption;
  } else {
    const newFilterOption = {
      ...filterOption,
      options: filterOption.options?.map((item) => ({
        ...item,
        ...(item.id === l2Code
          ? { isSelected: selected !== undefined ? selected : !item.isSelected }
          : {}),
      })),
    };

    newFilterOption.isSelected = newFilterOption.options
      ? newFilterOption.options.every((item) => item.isSelected)
      : newFilterOption.isSelected;
    newOptions[filterOptionIndex] = newFilterOption;
  }

  return newOptions;
};

export const convertOptionsToQuery = (filterId: string, options: IOption[]) => {
  const l1Codes = options
    .filter((item) => item.isSelected)
    .map((item) => item.id.toString());
  const l2Codes = options
    .filter((item) => !item.isSelected)
    .reduce((acc, filterItem) => {
      const selectedL2 = filterItem.options
        ?.filter((item) => item.isSelected)
        ?.map((item) => item.id.toString());

      return selectedL2 ? [...acc, ...selectedL2] : acc;
    }, [] as string[]);

  return {
    [`${filterId}${L1Suffix}`]: l1Codes,
    [`${filterId}${L2Suffix}`]: l2Codes,
  };
};

export const getUpdatedFiltersQueryParams = (
  filterId: string,
  selectedFilter: IFilterProp,
  options: IOption[],
  isSelected?: boolean
) => {
  const newOptions = getUpdatedFilterOptions(
    selectedFilter,
    options,
    isSelected
  );

  return convertOptionsToQuery(filterId, newOptions);
};

export const getChipValues = (options: IOption[]) => {
  return options
    .filter(
      (item) =>
        item.isSelected ||
        (item.options && item.options.some((option) => option.isSelected))
    )
    .map((item) => {
      if (item.isSelected) {
        return item.label;
      }

      const selectedL2Options =
        item.options?.filter((option) => option.isSelected) || [];

      return `${item.label} (${selectedL2Options.length}/${item.options?.length})`;
    });
};
